export default __webpack_public_path__ + "static/media/elevate-pyl-1.9dffe440.png";